module.exports = require('./helpers/bundle-url').getBundleURL('sif1r') + "paratime-selector-globe-testnet.52b04c00.svg";